import {hasServerErrorCode, ServerErrorResponse} from './server-error-code';

const CONFLICT = 409;
const FORBIDDEN = 403;
const GROUP_CONFLICT = 'GROUP_SETTINGS_CONFLICT';
const TEAM_PENDING = 'TEAM_BUILDING_OPERATION_PENDING';
const TEAM_CHANGED = ['TEAM_BUILDING_PARTICIPANTS_CHANGED', 'USER_REVISION_CONFLICT'];
const PAYROLL_PENDING = 'PAYROLL_OPERATION_PENDING';
const ACCESS_DENIED_KEY = 'GROUP_SETTINGS_ACCESS_DENIED';
const GROUP_CONFLICT_KEY = 'GROUP_SETTINGS_CONFLICT_HINT';
const GROUP_FAILED_KEY = 'GROUP_SETTINGS_SAVE_UNCONFIRMED';
const TEAM_PENDING_KEY = 'TEAM_BUILDING_PENDING_HINT';
const TEAM_CHANGED_KEY = 'TEAM_BUILDING_CHANGED_HINT';
const TEAM_FAILED_KEY = 'TEAM_BUILDING_SAVE_FAILED';

export function groupSettingsErrorKey(error: ServerErrorResponse): string {
  if (error && error.status === FORBIDDEN) { return ACCESS_DENIED_KEY; }
  return error && error.status === CONFLICT && hasServerErrorCode(error, GROUP_CONFLICT)
    ? GROUP_CONFLICT_KEY : GROUP_FAILED_KEY;
}

export function teamBuildingErrorKey(error: ServerErrorResponse): string {
  if (error && error.status === FORBIDDEN) { return ACCESS_DENIED_KEY; }
  if (error && error.status === CONFLICT) {
    if (hasServerErrorCode(error, TEAM_PENDING)) { return TEAM_PENDING_KEY; }
    if (TEAM_CHANGED.some(code => hasServerErrorCode(error, code))) { return TEAM_CHANGED_KEY; }
  }
  return TEAM_FAILED_KEY;
}

export function isPayrollOperationPending(error: ServerErrorResponse): boolean {
  return !!error && error.status === CONFLICT && hasServerErrorCode(error, PAYROLL_PENDING);
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/operation-conflict.ts